import type { StepDefinition } from "@/components/onboarding";
import { STEP_ORDER, type OnboardingStep } from "@/lib/stores/onboarding-store";

const STEP_LABELS: Record<OnboardingStep, string> = {
  org: "Organization",
  tier: "Select Plan",
  site: "Add Site",
  setup: "Setup",
};

/**
 * The onboarding steps as the progress indicator shows them, in the order the
 * store walks them. Derived rather than restated so a step added to
 * `STEP_ORDER` cannot be missing here, and kept apart from the layout so tests
 * can render the indicator without the auth provider.
 */
export const ONBOARDING_STEPS: StepDefinition[] = STEP_ORDER.map((id) => ({
  id,
  label: STEP_LABELS[id],
  path: `/onboarding/${id}`,
}));
